import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { LocationServiceConsentDrawer } from './_components/LocationServiceConsentDrawer';
import { LoginRedirectionConfirmModal } from './_components/LoginRedirectionConfirmModal';
import { RegionDrawer } from './_components/RegionDrawer';
import { ShareDrawer } from './_components/ShareDrawer';
import { TermsDrawer } from './_components/TermsDrawer';
import { WelloWebLinkModal } from './_components/WelloWebLinkModal';

export const GlobalModal = () => {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense>
        <ShareDrawer />
        <TermsDrawer />
        <WelloWebLinkModal />
        <RegionDrawer />
        <LocationServiceConsentDrawer />
        <LoginRedirectionConfirmModal />
      </Suspense>
    </ErrorBoundary>
  );
};
